module.exports = __webpack_public_path__ + "static/media/the-sunday-times.8301979c.jpg";